export default {
  title: '技术市场',
  subtitle: '技术市场',
  TopTitle: '技术市场',
  loginLogo: '/images/home/logo.png',
  subLogoImage: '/images/home/logo-ab.png',
  userImageTop: '/images/home/home_top_left_user.png', // 顶部头像默认图
  copyright: '',
  isFirstPage: true, // 配置首页不可关闭
  key: 'zg', // 配置主键,目前用于存储
  encPassword: 'pigxpigxpigxpigx', // 前后端数据传输的密钥
  validateCode: true, //是否开启验证码校验
  passwordEnc: true, //是否开启密码加密传输
  register: true, //是否开启注册
  connectSync: false, //是否开启互联同步
  domainAutoTenant: false, // 是否根据 domain 自动匹配租户
  formLoginClient: 'zg-jssc-user-login:163ff1f0e2ef4bfab9afa88bb45017ee', // 用户名密码登录的 client 信息
  smsLoginClient: 'app:app', // 验证码登录的 client 信息
  socialLoginClient: 'social:social', // 社交登录的 client 信息
  websocket: true, // 是否开启websocket
  dynamicCodeCache: false, //  是否开启动态代码缓存
  showJsonFlow: true, // 是否显示工作流
  showLog: false, // 是否显示错误日志
  whiteList: ['/login', '/404', '/401', '/lock'], // 配置无权限可以访问的页面
  whiteTagList: ['/login', '/404', '/401', '/lock'], // 配置不添加tags页面 （'/advanced-router/mutative-detail/*'——*为通配符）
  fistPage: {
    label: '首页',
    value: '/wel/index',
    params: {},
    query: {},
    group: [],
    close: false
  },
  // 配置菜单的属性
  menu: {
    props: {
      label: 'label',
      path: 'path',
      icon: 'icon',
      children: 'children'
    }
  }
}



// WEBPACK FOOTER //
// ./src/const/website.js